import { render, staticRenderFns } from "./ProjectListHomeComponent.vue?vue&type=template&id=48d420b0&scoped=true&"
import script from "./ProjectListHomeComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectListHomeComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProjectListHomeComponent.vue?vue&type=style&index=0&id=48d420b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d420b0",
  null
  
)

export default component.exports